import { defineMessages, IntlShape } from "react-intl";

import { FrequencyStatus } from "@mapmycustomers/shared/enum/frequency";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<FrequencyStatus>({
  [FrequencyStatus.PAST_DUE]: {
    id: "frequencyStatus.pastDue",
    defaultMessage: "Past Due",
  },
  [FrequencyStatus.UNKNOWN]: {
    id: "frequencyStatus.unknown",
    defaultMessage: "Unknown",
  },
  [FrequencyStatus.UP_TO_DATE]: {
    id: "frequencyStatus.upToDate",
    defaultMessage: "Up to Date",
  },
  [FrequencyStatus.UPCOMING]: {
    id: "frequencyStatus.upcoming",
    defaultMessage: "Upcoming",
  },
});

const getFrequencyStatusDisplayName = (intl: IntlShape, status: FrequencyStatus) =>
  getDisplayName(intl, messages, status, "FrequencyStatus");

export default getFrequencyStatusDisplayName;
